import React, { Component } from 'react';
import { Form, Input, Row, Col, Button, Space, InputNumber, Radio, Select, Table, AutoComplete, Checkbox, Typography } from 'antd';
import { FullHeightContainerLayout, CopyInput } from "components";
import { diff } from 'deep-object-diff';
import _ from 'lodash';
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';
import { nameRules, descriptionRules } from 'common/FormValidationRules';

class ManageSystemConnectionJdbcPostgresql extends Component {

    constructor(props) {
        super(props);
        this.state = {
            connectionDefault: {
                name: '',
                description: '',
                jdbcUrl: '',
                username: '',
                password: ''
            },
            readOnlyView: this.props.action === "view",
            showPassword: false,
            showUsername: true,
            passwordStrength: '',
            passwordStrengthColor: 'secondary'
        };
        this.formRef = React.createRef();
        this.emptyObject = {};
    }

    componentDidMount() {
        if (this.props.connection) {
            this.formRef.current.setFieldsValue({ ...this.props.connection });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.connection && prevProps.connection !== this.props.connection) {
            this.formRef.current.setFieldsValue({ ...this.props.connection });
        }
    }

    getFormErrors = fieldName => {
        if (this.props.formErrors && this.props.formErrors[fieldName]) {
            return {
                help: this.props.formErrors[fieldName],
                validateStatus: "error"
            }
        }
        return this.emptyObject;
    }

    onFormSubmit = (formData) => {
        let connection = { ...formData };
        connection.jdbcType = 'postgresql';
        if (this.props.action === "create") {
            connection.active = true;
            this.props.onSave(connection);
        }
        else {
            let diffObject = diff(this.props.connection, connection);
            let updatedObject = {};
            for (let key in diffObject) {
                if (diffObject[key] !== undefined) {
                    updatedObject[key] = connection[key];
                }
            }
            if (_.isEmpty(updatedObject) === false) {
                updatedObject.version = this.props.connection.version;
            }

            this.props.onSave(this.props.connection.connectionId, updatedObject);
        }
    }

    isReadOnlyView = () => {
        return (this.state.readOnlyView || !(this.props.permission.canEdit || this.props.permission.canAdd));
    }

    isSaveAllowed = () => {
        if (this.props.action === "edit") {
            return this.props.permission.canEdit;
        }
        else if (this.props.action === "create") {
            return this.props.permission.canAdd;
        }
        return false;
    }

    render() {
        return (
            <Form
                layout="horizontal"
                labelAlign="right"
                labelCol={{ md: { span: 24 }, lg: { span: 6 }, xl: { span: 5 }, xxl: { span: 3 } }}
                ref={this.formRef}
                name="basic"
                onFinish={this.onFormSubmit}
                initialValues={this.state.connectionDefault}
                onValuesChange={this.props.onValuesChanged}
                style={{ height: "100%" }}>
                <FullHeightContainerLayout
                    showFooter={true}
                    content={
                        <>
                            <Form.Item
                                labelAlign="right"
                                className="wrap-label"
                                {...this.getFormErrors("name")}
                                label="Connection Name"
                                name={["name"]}
                                rules={nameRules}
                                hasFeedback>
                                <Input placeholder="Connection Name" readOnly={this.isReadOnlyView()} />
                            </Form.Item>
                            <Form.Item
                                labelAlign="right"
                                className="wrap-label"
                                {...this.getFormErrors("description")}
                                label="Description"
                                name={["description"]}
                                rules={descriptionRules}
                                hasFeedback>
                                <Input placeholder="Description" readOnly={this.isReadOnlyView()} />
                            </Form.Item>
                            <Form.Item
                                labelAlign="right"
                                className="wrap-label"
                                {...this.getFormErrors("jdbcUrl")}
                                label="JDBC URL"
                                name={["jdbcUrl"]}
                                rules={[{ required: true, message: `JDBC URL is required` }]}
                                hasFeedback>
                                <Input placeholder="JDBC URL" readOnly={this.isReadOnlyView()} />
                            </Form.Item>
                            <Form.Item
                                labelAlign="right"
                                className="wrap-label"
                                {...this.getFormErrors("username")}
                                label="Username"
                                name={["username"]}
                                rules={[{ required: true, message: `Username is required` }]}
                                hasFeedback>
                                <Input 
                                    placeholder="Username" 
                                    readOnly={this.isReadOnlyView()} 
                                    autoComplete="off"
                                    type={this.state.showUsername ? "text" : "password"}
                                    suffix={
                                        !this.isReadOnlyView() && (
                                            this.state.showUsername ? (
                                            <EyeTwoTone onClick={() => this.setState({ showUsername: false })} />
                                            ) : (
                                            <EyeInvisibleOutlined onClick={() => this.setState({ showUsername: true })} />
                                            )
                                        )
                                    }
                                />
                            </Form.Item>
                            <Form.Item
                                labelAlign="right"
                                className="wrap-label"
                                {...this.getFormErrors("password")}
                                label="Password"
                                name={["password"]}
                                rules={this.props.action === "create" ? [{ required: true, message: `Password is required` }] : []}
                                hasFeedback
                            >
                                <Input.Password
                                    placeholder={this.props.action === "create" ? "Password" : "***************************"}
                                    readOnly={this.isReadOnlyView()}
                                    autoComplete="new-password"
                                    iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                />
                            </Form.Item>
                        </>
                    }
                    footer={
                        <Row>
                            <Col span={24} className="footer-right-column">
                                <Space>
                                    <Button onClick={this.props.onCancel}>Cancel</Button>
                                    <Button type="primary" htmlType="submit" disabled={this.isReadOnlyView() || !this.isSaveAllowed()}>Save</Button>
                                </Space>
                            </Col>
                        </Row>
                    }>
                </FullHeightContainerLayout>
            </Form>
        );
    }
}

export default ManageSystemConnectionJdbcPostgresql